import React from 'react';
import { ManifestBundleProduct } from './NewManifestBundleProduct';
import {
    ManifestBundleHR as HR,
} from '../../../../Style/Manifest';

export const ProductsModal = ({
    cta,
    bundleTitle,
    productGroups,
    productTypes,
    selectedProductGroup,
    recommendedProductGroup,
    formattedProductType,
    selectProductGroup,
    onQuantityChange,
    showOtherBrands,
    showDescription,
    rounderSet,
    close,
    bundleShortName,
    interview,
    handleDropdownSelect,
    displayUnits,
    isDashboard
}) => {
    const productGroupRows = [];
    const selectedProductGroupRow = [];
    const trashTypes = ["Kitchen", "Small", "Compost", "Recycling", "Outdoor"]

    const getTrashNeeds = (interview) => {
        const res = {};
        const trashMap = {};

        interview.trashPreferences.forEach(t => {
            const { frequency, type } = t;
            trashMap[type] = frequency;
        });

        trashTypes.forEach(trashType => {
            if (!trashMap[trashType]) {
                res[`TrashBags${trashType}`] = true;
            }
        })
        return res;
    }
    
    if (cta === "change") {
        for (let i = 0; i < productGroups.length; i++) {
            const productGroup = productGroups[i];
            const { groupName, pricePerArticle } = productGroup;
            if(!selectedProductGroup && groupName === recommendedProductGroup) {
                selectedProductGroupRow.push(
                    <ManifestBundleProduct
                        key={groupName}
                        productGroup={productGroup}
                        bundleShortName={bundleShortName}
                        onQuantityChange={onQuantityChange}
                        showDescription={showDescription}
                        recommended={true}
                        selectProductGroup={selectProductGroup}
                        hideProductType={true}
                        cta={cta}
                        isDashboard={isDashboard}
                    />
                )
                selectedProductGroupRow.push(<HR />)
            } else if (selectedProductGroup && selectedProductGroup.groupName === groupName) {
                selectedProductGroupRow.push(
                    <ManifestBundleProduct
                        key={groupName}
                        productGroup={productGroup}
                        bundleShortName={bundleShortName}
                        onQuantityChange={onQuantityChange}
                        showDescription={showDescription}
                        selected={true}
                        selectProductGroup={selectProductGroup}
                        hideProductType={true}
                        cta={cta}
                        isDashboard={isDashboard}
                        hasSelectedProductGroup={true}
                        showRemove={true}
                    />
                )
                selectedProductGroupRow.push(<HR />)
            } else {
                productGroupRows.push(
                    <ManifestBundleProduct
                        key={groupName}
                        productGroup={productGroup}
                        bundleShortName={bundleShortName}
                        onQuantityChange={onQuantityChange}
                        hideProductType={true}
                        showDescription={showDescription}
                        selected={false}
                        selectProductGroup={selectProductGroup}
                        pricePerArticle={pricePerArticle}
                        cta={cta}
                        isDashboard={isDashboard}
                        hasSelectedProductGroup={!!selectedProductGroup}
                    />
                )
                if (productGroups.length) {
                    if (i < productGroups.length - 1) {
                        productGroupRows.push(<HR />)
                    }
                }
            }
        }
    } else {
        const needsTrashTypes = getTrashNeeds(interview);

        for (let i = 0; i < Object.entries(productTypes).length; i++) {
            const productGroup = Object.values(productTypes)[i].preferred;
            const { groupName, articles, productType, proposedArticles } = productGroup;

            const onlyOffering = !Object.values(rounderSet[productType].additional).length;
            productGroupRows.push(
                <ManifestBundleProduct
                    key={groupName}
                    productGroup={productGroup}
                    bundleShortName={bundleShortName}
                    onQuantityChange={onQuantityChange}
                    showDescription={showDescription}
                    showOtherBrands={() => showOtherBrands(productType, bundleShortName)}
                    selectProductGroup={selectProductGroup}
                    onlyOffering={onlyOffering}
                    selected={false}
                    hideProductType={false}
                    articles={articles !== undefined ? articles : proposedArticles}
                    cta={cta}
                    handleDropdownSelect={handleDropdownSelect}
                    needsTrashQuestion={needsTrashTypes[productType]}
                    isDashboard={isDashboard}
                />
            )
            if (Object.entries(productTypes).length) {
                if (i < Object.entries(productTypes).length - 1) {
                    productGroupRows.push(<HR />)
                }
            }
        }
    }
    return (
        <div className="modal-container" id={`${cta}-products-modal-container`}>
            <div id={`${cta}-products-modal`} className="products-modal slideInRight animated-fast">
                <div className="products-modal-top-row">
                    <div onClick={() => close(cta)} className="fa fa-chevron-up products-modal-back" />
                    <div className="products-modal-title">{cta === "add" ? `${bundleTitle}` : selectedProductGroup ? `Change ${formattedProductType}` : `Add ${formattedProductType}`}</div>
                </div>
                <div className="products-modal-body">
                    {selectedProductGroupRow}
                    {productGroupRows}
                </div>
            </div>
        </div>
    )
}
